import React from "react";
import JsonView from "react-json-view";

import TransectEvolution from "../visualization/TransectEvolution";
import { FeatureType } from "../../../common/metadata";

/**
 * @component
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.data - Feature object with a `featureType`.
 * @param {Object} props.minmaxResults - Global min/max values to be passed to visualization components.
 *
 */
const FeatureInfo = ({ data, minmaxResults }) => {
  const componentMap = {
    [FeatureType.TRANSECT]: (
      <TransectEvolution minmaxResults={minmaxResults} data={data} />
    ),
  };

  const hasComponent = data && data.featureType in componentMap;

  return (
    <div>
      {hasComponent && componentMap[data.featureType]}
      {!hasComponent && (
        <JsonView src={data} enableClipboard={false} displayDataTypes={false} />
      )}
    </div>
  );
};

export default FeatureInfo;
